var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.5372C7 22.4265 7.22292 21.3613 7.66876 20.3414C8.1146 19.3219 8.76591 18.4792 9.62268 17.8131L23.4122 7L24.3548 7.87239C24.7574 8.24605 25.0063 8.70629 25.1016 9.25311C25.1969 9.79958 25.1171 10.3205 24.8623 10.8159L21.8248 16.9657L39.8117 16.9657C40.1483 16.9657 40.4304 17.0825 40.658 17.316C40.886 17.5495 41 17.8389 41 18.1841C41 18.5294 40.886 18.8152 40.658 19.0416C40.4304 19.2684 40.1483 19.3817 39.8117 19.3817L17.9573 19.3817L22.0301 11.164L11.0367 19.8155C10.4672 20.2673 10.0483 20.8199 9.77978 21.4736C9.5113 22.1275 9.37706 22.8154 9.37706 23.5372L9.37706 33.3842C9.37706 34.842 9.86776 36.0731 10.8492 37.0777C11.8309 38.0819 13.0388 38.584 14.4726 38.584L22.7512 38.584C23.6873 38.584 24.4718 38.2623 25.1047 37.619C25.7381 36.9757 26.0547 36.1783 26.0547 35.227L26.0547 24.4586L28.4313 24.4586L28.4313 35.2153C28.4313 36.822 27.8791 38.1878 26.7748 39.3127C25.6702 40.4376 24.329 41 22.7512 41L14.4742 41C12.3812 41 10.6123 40.2612 9.16758 38.7836C7.72253 37.306 7 35.5062 7 33.3842L7 23.5372Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d2e90033aafb5f30a4bce1f14fddd467.svg";
export { ForwardRef as ReactComponent };